<mat-progress-bar mode="determinate" [value]="value"></mat-progress-bar><span>{{ completed }} / {{ total }}</span>
